import { render, staticRenderFns } from "./AddApi.vue?vue&type=template&id=545b7528&scoped=true&"
import script from "./AddApi.vue?vue&type=script&lang=js&"
export * from "./AddApi.vue?vue&type=script&lang=js&"
import style0 from "./AddApi.vue?vue&type=style&index=0&id=545b7528&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b7528",
  null
  
)

export default component.exports